import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22Albert_Sans%22,%22arguments%22:[{%22subsets%22:[%22latin%22],%22variable%22:%22--font-albert-sans%22,%22display%22:%22swap%22,%22preload%22:false}],%22variableName%22:%22fontAlbertSans%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Albert Sans', 'Albert Sans Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
